/* eslint-disable react/destructuring-assignment */
import { IconEye } from '@tabler/icons-react';
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import DeleteConfirmPopover from '../../../../../components/DeleteConfirmPopover';
import { DismissalType } from '../../../../../models/core/dismissals.type';
import theme from '../../../../../theme';

type DataViewActionProps = {
  item: DismissalType;
  confirmActionResult(item: DismissalType, action: string, confirmed: boolean): void;
};

export default function DataViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Visualizar">
        <ActionIcon
          size="sm"
          radius="sm"
          color="primary"
          style={{ borderColor: theme?.colors?.primary?.[6] }}
          variant="outline"
          onClick={() => {
            props.confirmActionResult(props.item, 'visualizar', true);
          }}
        >
          <IconEye size={15} color={theme?.colors?.primary?.[6]} />
        </ActionIcon>
      </Tooltip>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o desligamento."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult(props.item, 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult(props.item, 'excluir', false);
        }}
      />
    </Group>
  );
}
